document.addEventListener('DOMContentLoaded', function() {

  // Hover open/close
  document.querySelectorAll('.header__inline-menu .mega-menu').forEach(function(details) {
    let timeout;

    details.addEventListener('mouseenter', function() {
      clearTimeout(timeout);
      this.setAttribute('open', '');
    });

    details.addEventListener('mouseleave', function() {
      const el = this;
      timeout = setTimeout(function() {
        el.removeAttribute('open');
      }, 100);
    });
  });

  // Click to navigate on top level items
  document.querySelectorAll('.header__inline-menu .mega-menu > summary').forEach(function(summary) {
    summary.addEventListener('click', function(e) {
      const target = e.target;
      const isCaret = target.closest('.svg-wrapper');
      if (!isCaret) {
        e.preventDefault();
        e.stopPropagation();
        const url = this.closest('.mega-menu').querySelector('a') ? null : '#';
        const dataUrl = this.getAttribute('data-url');
        if (dataUrl) {
          window.location.href = dataUrl;
        }
      }
    });
  });

});
